import React from "react"
import { FaBars } from "react-icons/fa"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import classes from "./SettingTopbar.module.scss"

const SettingTopbar = props => {
  const { setOpenSettingSidebar } = props

  const i18n = useTranslation()[1]

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <div className={classes["container"]}>
      <button
        id="setting-hamburger-button"
        onClick={() => setOpenSettingSidebar(prev => !prev)}
        className={clsx(
          classes["button"],
          isLtr && classes["button-ltr"]
        )}
      >
        <FaBars
          size={20}
          color="white"
        />
      </button>
    </div>
  )
}

export default SettingTopbar